import { Routes, Route , Navigate  } from 'react-router-dom';
import {ImpersonationStart, Login, Dashboard, Users, AddBalanceCredit, NotFoundPage, Roles, FinancialReport, Expenses, Tickets, Providers, FormRoles, FinancialStats, Settings, BalanceRecords, Clients, CreditAccounts, AdAccounts, AdAccountDetails, Leads, PaymentsInfo, AuditLog } from '../pages';
import { MainLayout } from '../layout';
import ProtectedRoute from './ProtectedRoute';
import { useCurrentUser } from '../utils/context/UserProvider';
import RedirectIfSignedIn from './RedirectIfSignedIn';


const Routers = () => {
  const { currentUser } = useCurrentUser()

  return (
    <div>
      <Routes>

        <Route path="/impersonation/start" element={<ImpersonationStart />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        {/* **************************************Roles*Start******************************************* */}
        <Route
          path="/settings/roles"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Roles />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/roles/New"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormRoles />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/roles/update/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FormRoles />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        {/* **************************************Roles*End******************************************* */}

        {/* **************************************Users*Start******************************************* */}

        <Route
          path="/settings/users"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Users />
              </MainLayout>
            </ProtectedRoute>
          }
        />



        {/* **************************************Users*End******************************************* */}

        {/* **************************************Equations*End******************************************* */}

        <Route
          path="/settings/account"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Settings />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {
          currentUser?.role?.name === 'SuperAdmin' && currentUser?.isOwner &&

          <Route
            path="/settings/payments-info"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PaymentsInfo />
                </MainLayout>
              </ProtectedRoute>
            }
          />

        }

        {
          currentUser?.role?.name === 'SuperAdmin' &&

          <Route
            path="/settings/audit-log"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AuditLog />
                </MainLayout>
              </ProtectedRoute>
            }
          />

        }




        <Route
          path="/ad-accounts"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AdAccounts />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings/providers"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Providers />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Expenses />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tickets"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Tickets />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/credit-accounts"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CreditAccounts />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-balance-credit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AddBalanceCredit />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/leads"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Leads />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        {
          (['SuperAdmin', 'Admin'].includes(currentUser?.role?.name) ||
            (currentUser?.role?.permissions || []).some(
              (p) => p?.section === 'statistics' && p?.access?.read === true
            )) &&
          <Route
            path="/financial-stats"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <FinancialStats />
                </MainLayout>
              </ProtectedRoute>
            }
          />
        }

        <Route
          path="/top-ups"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FinancialReport />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/credit-accounts-history"
          element={
            <ProtectedRoute>
              <MainLayout>
                <BalanceRecords />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Clients />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ad-accounts/details/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AdAccountDetails />
              </MainLayout>
            </ProtectedRoute>
          }
        />



        <Route path="/login" element={
          <RedirectIfSignedIn>
            <Login />
          </RedirectIfSignedIn>
        } />

        <Route path="/sign-up" element={<Navigate to="/login" replace />} />
        <Route path="/signup" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<ProtectedRoute>
          <MainLayout> <NotFoundPage /> </MainLayout >
        </ProtectedRoute>
        } />
      </Routes>
    </div>
  );
};

export default Routers;
